import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m38.683 14.998-6.697 6.62 3.48 3.44c.963.951-.48 2.378-1.443 1.427L19.438 12.067l-4.202-4.154c-.962-.951.482-2.378 1.444-1.427l3.48 3.441 6.697-6.614c.963-.95 2.406.477 1.443 1.428l-6.696 6.613 8.939 8.837 6.696-6.62c.962-.952 2.406.475 1.444 1.427ZM13.617 28.803c-3.597 3.813-3.414 11.526 1.044 14.28.491.304.64.944.334 1.43a1.056 1.056 0 0 1-1.445.33c-5.691-3.517-5.904-12.818-1.417-17.507l-.057-.056a9.653 9.653 0 0 1 .001-13.759l4.425-4.362 1.437 1.434-4.419 4.356a7.651 7.651 0 0 0 0 10.904l2.356 2.33a7.849 7.849 0 0 0 5.518 2.26c2.07 0 4.055-.814 5.518-2.26l4.41-4.367 1.45 1.432-4.416 4.361a9.902 9.902 0 0 1-6.962 2.851 9.902 9.902 0 0 1-6.962-2.85l-.815-.807Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPlugOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlugOutlined_default = SvgPlugOutlined;

export { PlugOutlined_default as default };
